import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  stats: () => client.get("/stats").then((r) => r.data),
  seed: () => client.post("/seed").then((r) => r.data),

  listStaff: () => client.get("/staff").then((r) => r.data),
  createStaff: (data) => client.post("/staff", data).then((r) => r.data),
  updateStaff: (id, data) => client.patch(`/staff/${id}`, data).then((r) => r.data),
  deleteStaff: (id) => client.delete(`/staff/${id}`).then((r) => r.data),

  listRoutes: () => client.get("/routes").then((r) => r.data),
  createRoute: (data) => client.post("/routes", data).then((r) => r.data),
  updateRoute: (id, data) => client.patch(`/routes/${id}`, data).then((r) => r.data),
  deleteRoute: (id) => client.delete(`/routes/${id}`).then((r) => r.data),

  listAssignments: (params) => client.get("/assignments", { params }).then((r) => r.data),
  upsertAssignment: (data) => client.put("/assignments", data).then((r) => r.data),
  deleteAssignmentSlot: (params) => client.delete("/assignments", { params }).then((r) => r.data),

  listAbsences: (params) => client.get("/absences", { params }).then((r) => r.data),
  createAbsence: (data) => client.post("/absences", data).then((r) => r.data),
  updateAbsence: (id, data) => client.patch(`/absences/${id}`, data).then((r) => r.data),
  deleteAbsence: (id) => client.delete(`/absences/${id}`).then((r) => r.data),

  replacements: (params) => client.get("/replacements", { params }).then((r) => r.data),

  listVehicles: () => client.get("/vehicles").then((r) => r.data),
  createVehicle: (data) => client.post("/vehicles", data).then((r) => r.data),
  updateVehicle: (id, data) => client.patch(`/vehicles/${id}`, data).then((r) => r.data),
  deleteVehicle: (id) => client.delete(`/vehicles/${id}`).then((r) => r.data),

  listVehicleServices: (params) => client.get("/vehicle-services", { params }).then((r) => r.data),
  createVehicleService: (data) => client.post("/vehicle-services", data).then((r) => r.data),
  updateVehicleService: (id, data) => client.patch(`/vehicle-services/${id}`, data).then((r) => r.data),
  deleteVehicleService: (id) => client.delete(`/vehicle-services/${id}`).then((r) => r.data),

  vehicleReplacements: (params) => client.get("/vehicles/replacements", { params }).then((r) => r.data),

  listVehicleAssignments: (params) => client.get("/vehicle-assignments", { params }).then((r) => r.data),
  upsertVehicleAssignment: (data) => client.put("/vehicle-assignments", data).then((r) => r.data),
  deleteVehicleAssignment: (params) => client.delete("/vehicle-assignments", { params }).then((r) => r.data),

  bulkVehicles: (rows) => client.post("/vehicles/bulk", rows).then((r) => r.data),

  importCsvPreview: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/import-csv?dry_run=true", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
  importCsvCommit: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/import-csv?dry_run=false", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },

  coverage: (start_date, end_date) =>
    client.get("/coverage", { params: { start_date, end_date } }).then((r) => r.data),
};
